import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';


export interface PeriodicElement {
  name: string;
  slno: number;
  information: string;
  highlight?: boolean;
  multipleLines?:boolean;
  informations?:[];

}

export interface PeriodicElement1 {
  view: string;
  slno: number;
  information: string;
  highlight?: boolean;
}
// export interface PeriodicElement2 {
//   view: string;
//   slno: number;
//   information: string;
//   highlight?: boolean;
//   link
// }
const ELEMENT_DATA: PeriodicElement[] = [
  {slno: 1, name: 'NAME OF THE SCHOOL', information:'RIVER VALLEY SCHOOL', highlight: false},
  {slno: 2, name: 'AFFILIATION NO.', information: '330251', highlight: false},
  // {slno: 3, name: 'SCHOOL CODE', information:'SVM43343', highlight: false },
  {slno: 3, name: 'COMPLETE ADDRESS', information: 'Anand Vihar , Institutional Area, SH-55 , Begusarai -851218', highlight: false},
  {slno: 4, name: 'PRINCIPAL NAME', information: 'Ananya Pal', highlight: true},
  {slno: 5, name: 'CONTACT DETAILS', information: '7004321674 / rvsbgs08@gmail.com', highlight: true, multipleLines:true}
];

// const ELEMENT_DATA1: PeriodicElement1[] = [
//   {slno: 1, information: 'COPIES OF AFFILIATION/ UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY', view:'View', highlight: true},
//   {slno: 2, information: 'COPIES OF SOCIETIES/ TRUST/ COMPANY REGISTRATION/ RENEWAL CERTIFICATE, AS APPLICABLE', view: 'View', highlight: true},
//   {slno: 3, information: 'COPIES OF AFFILIATION/ UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY', view:'View', highlight: true },
//   {slno: 4, information: 'COPIES OF SOCIETIES/ TRUST/ COMPANY REGISTRATION/ RENEWAL CERTIFICATE, AS APPLICABLE', view: 'View', highlight: true},
//   {slno: 5, information: 'COPIES OF SOCIETIES/ TRUST/ COMPANY REGISTRATION/ RENEWAL CERTIFICATE, AS APPLICABLE', view: 'View', highlight: true}
// ];

// const ELEMENT_DATA2: PeriodicElement2[] = [
//   {slno: 1, information: 'FEE STRUCTURE OF THE SCHOOL',  link: 'https://www.google.com', linkText: 'Visit Google' , highlight: true,},
//   {slno: 2, information: 'ANNUAL ACADEMIC CALENDAR', view: 'View', highlight: true},
//   {slno: 3, information: 'LIST OF THE SCHOOL MANAGEMENT COMMITTEE (SMC)', view:'View', highlight: true },
//   {slno: 4, information: 'LIST OF THE PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS', view: 'View', highlight: true},
//   {slno: 5, information: 'LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY', view: 'View', highlight: true}
// ];
@Component({
  selector: 'app-pub-disclosure',
  templateUrl: './pub-disclosure.component.html',
  styleUrls: ['./pub-disclosure.component.scss']
})
export class PubDisclosureComponent {


  
  displayedColumns: string[] = ['slno', 'name', 'information'];
  dataSource = ELEMENT_DATA;

  displayedColumns1: string[] = ['slno', 'information', 'link'];
 /* dataSource1 = new MatTableDataSource([
    {slno: 1, information: 'INFORMATION OF THE SCHOOL', link: 'https://drive.google.com/file/d/1kAgN82NmyBs4M9CZkkg7_FdoW2QGUhhJ/view',linkText: 'View', highlight: true},
    {slno: 2, information: 'MANAGING COMMITTEE', link: 'https://drive.google.com/open?id=0B16UHevyRYFHSDRGb0FMQTVOYVRRVHlNOWpWM2hmNG84eDZv', linkText: 'View', highlight: true},
    {slno: 3, information: 'SALARY DETAILS', link: 'https://drive.google.com/file/d/1b7YJXKdl9Kg7iW8Rd4ESFOaq-YWV6pDC/view', linkText: 'View', highlight: true},
    {slno: 4, information: 'STAFF DETAILS', link: 'https://drive.google.com/file/d/1naLE4o2RbQomJwNF7yFjX7jqX-7ASyml/view',linkText: 'View', highlight: true},
    {slno: 5, information: 'ACADEMIC SESSION (1st April to 31st March )', link:'https://drive.google.com/file/d/1yN2XR1qidu_iQHAC9q6f2uBKRGPyYStK/view',linkText: 'View', highlight: true },
    {slno: 6, information: 'CLASS WISE STRENGTH DETAILS', link: 'https://drive.google.com/file/d/1AjfDo6gfXnUaQhtpk-NYBGcjNrLiM2MH/view',linkText: 'View', highlight: true},
    {slno: 7, information: 'LIBRARY INFORMATION', link: 'https://drive.google.com/file/d/10AD3gcrM67WokG7s05-ihT7_mH99GdHO/view',linkText: 'View', highlight: true},
    {slno: 8, information: 'HOLIDAY LIST',  link: 'https://drive.google.com/file/d/15kcrrGs4xT3e5Kr37nzsclt_-3qFGBdt/view', linkText: 'View' , highlight: true,},
    {slno: 9, information: 'DRESSES', routerLink: '/dresses', linkText: 'View', highlight: true},
    {slno: 10, information: 'TRANSFER CERTIFICATE', link: 'https://docs.google.com/spreadsheets/d/18_f_yrfpNT30cg3LIefrnsROuskOokIjGLcDny5YIUs/edit#gid=0', linkText: 'View', highlight: true},
    {slno: 11, information: 'AFFIDAVIT', link: 'https://drive.google.com/file/d/104i-ICnm-GsOIu7GaUMxDDOFkuStYVFR/view',linkText: 'View', highlight: true},
    {slno: 12, information: 'DECLARATION OF BOOKS', link:'https://drive.google.com/file/d/1hdNHBcLS3QXPm8jl4d4gSWd33sntTt7A/view',linkText: 'View', highlight: true },
    {slno: 13, information: 'FIRE SAFETY CERTIFICATE',  link: 'https://drive.google.com/file/d/1B-ShMXILYVupBRNYi3RTfNSSc63-vd6a/view', linkText: 'View' , highlight: true,},
    {slno: 14, information: 'LAND CERTIFICATE', link: 'https://drive.google.com/file/d/1mWiKZXQZuWIRuMgoNCXsl8L0oPxJv285/view', linkText: 'View', highlight: true},
    {slno: 15, information: 'INFRASTRUCTURE DETAIL', link: 'https://drive.google.com/file/d/14jMOJ2tP6jx-yY56MUI_t8Mf0mvjWlfN/view', linkText: 'View', highlight: true},
    {slno: 16, information: 'LETTER FIXING FEE', link: 'https://drive.google.com/file/d/1JIGFuXr8sfpksBPfM20UjvJ3txengmnV/view',linkText: 'View', highlight: true},
    {slno: 17, information: 'NOC', link:'https://drive.google.com/file/d/1PM0ClZr-6lpXql_s79zpmdSDFxat8wvz/view',linkText: 'View', highlight: true },
    {slno: 18, information: 'NOTICE FOR CODE OF CONDUCT', link:'https://drive.google.com/file/d/1fPWQX_Km6kjidgWolphUuXcEDMfdCFq7/view',linkText: 'View', highlight: true },
    {slno: 19, information: 'RTE CERTIFICATE', link:'https://drive.google.com/file/d/1qVy9IUEzs0L1Qr1utEkcPwl90VO30nwn/view',linkText: 'View', highlight: true },
    {slno: 20, information: 'TRUST PAPER', link:'https://drive.google.com/file/d/1j_M_DWlAwMr0OpEjfcaM2Ca8hyQBoShw/view',linkText: 'View', highlight: true },
   // {slno: 6, information: 'ADMISSION PERIOD(March to July)', link: 'https://drive.google.com/file/d/1naLE4o2RbQomJwNF7yFjX7jqX-7ASyml/view',linkText: 'View', highlight: true},
 
]); */

dataSource1 = new MatTableDataSource([
  {slno: 1, information: '+2 AFFILIATION CERTIFICATE', link: 'https://drive.google.com/file/d/1DI-0XImsiyHvtMew4nNrhjJf_xMqCKRN/view?usp=sharing',linkText: 'View', highlight: true},
  // {slno: 2, information: 'TRUST PAPER', link:'https://drive.google.com/file/d/1j_M_DWlAwMr0OpEjfcaM2Ca8hyQBoShw/view',linkText: 'View', highlight: true },
  {slno: 3, information: 'NO OBJECTION CERTIFICATE', link:'https://drive.google.com/file/d/12EqAkBtghinh497TNeAtSYIfse6Fm5Ti/view?usp=sharing',linkText: 'View', highlight: true },
  {slno: 4, information: 'RECOGNITION CERTIFICATE UNDER RTE ACT', link:'https://drive.google.com/file/d/1fku2fiK3AC2ZLzfxKLXwKcN9RDIh5oyI/view?usp=sharing',linkText: 'View', highlight: true },
  {slno: 5, information: 'FIRE SAFETY CERTIFICATE',  link: 'https://drive.google.com/file/d/1U3PExwSWnfZmM84rA306v2671q3eRiHR/view?usp=sharing', linkText: 'View' , highlight: true,},
  {slno: 6, information: 'WATER, HEALTH AND SANITATION CERTIFICATE',  link: 'https://drive.google.com/file/d/1_KyaEoqN-F88FswBBzHpo9SpdIEEu4CS/view?usp=sharing', linkText: 'View' , highlight: true,},
  {slno: 7, information: 'BUILDING SAFETY CERTIFICATE',  link: 'https://drive.google.com/file/d/10zNWJDjqQsD7L18Fo2Ov-GgcsQdlU4ha/view?usp=sharing', linkText: 'View' , highlight: true,},
  {slno: 8, information: 'SOCITIES REGISTRATION',  link: 'https://drive.google.com/file/d/1Hjvlj3ORpkG7sQ7IO-rsQiHMx5_4N3Js/view?usp=sharing', linkText: 'View' , highlight: true,},
  // {slno: 8, information: 'SCHOOL INFORMATION',  link: 'https://drive.google.com/file/d/1wKABRVSq3ujZB1xXwb1LYvZdv0p9OIE5/view?usp=sharing', linkText: 'View' , highlight: true,},
  // {slno: 9, information: 'SELF AFFIDAVIT OF SCHOOL',  link: 'https://drive.google.com/file/d/1c1SLy12SZxVN5_6s_z9umKiVP0VTQEMS/view?usp=sharing', linkText: 'View' , highlight: true,}
  
]);
  
  

  highlightRow(row: PeriodicElement) {
    this.dataSource.forEach((data: PeriodicElement) => {
      data.highlight = data === row;
    });
  }
  
  displayedColumns2: string[] = ['slno', 'information', 'link'];
  dataSource2 = new MatTableDataSource([
      {slno: 1, information: 'FEE STRUCTURE OF THE SCHOOL',  link: 'https://drive.google.com/file/d/1KM5XZAxiud8WYzNY8PCmocODAVLZwpgI/view?usp=sharing', linkText: 'View' , highlight: true,},
       {slno: 2, information: 'ANNUAL ACADEMIC CALENDAR SR', link: '', linkText: 'View', highlight: true},
      {slno: 3, information: 'ADF FEE STRUCTURE 2026-2027', link: 'https://drive.google.com/file/d/1AWpXjrHmk6AauqKjo5IPQkHLTp-4lCf6/view?usp=sharing', linkText: 'View', highlight: true},
      
      {slno: 4, information: 'MANAGING COMMITTEE', link: 'https://drive.google.com/file/d/1Oy8zMW15u0TnGieOIQs98xYFNqfE4KMH/view?usp=sharing', linkText: 'View', highlight: true},
      // {slno: 5, information: 'PARENT TEACHER ASSOCATION(PTA) MEMBERS', link: '', linkText: 'View', highlight: true},
      // {slno: 6, information: 'LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY', link: 'https://drive.google.com/file/d/1aiVXAgA-TDr9MEWbEs0KV5CIbwLng_qc/view?usp=sharing',linkText: 'View', highlight: true},
      // {slno: 7, information: 'CLASSWISE STRENGTH', link: 'https://drive.google.com/file/d/1k921eqcW6J5kYIRd-023hGUJyUoJ-Ite/view?usp=sharing',linkText: 'View', highlight: true},
      // {slno: 8, information: 'DETAILS OF CURRICULUM', link: 'https://drive.google.com/file/d/1y_UiQJtTkG7RlVE_DhGYG9knKE0fMHdA/view?usp=sharing',linkText: 'View', highlight: true},
      // {slno: 9, information: 'BOOK LIST(25-26)', link: 'https://docs.google.com/spreadsheets/d/1o_nS0CIvwsKVAuHBD6kSIUrOfeOL0aFd/edit?usp=sharing&ouid=109062213714886223435&rtpof=true&sd=true',linkText: 'View', highlight: true},
      // {slno: 10, information: 'TRANSFER CERTIFICATE (SAMPLE)', link: 'https://drive.google.com/file/d/1jGnCCclFhelcZh8hQMO1o63s3JytM6V5/view?usp=sharing',linkText: 'View', highlight: true},
      // {slno: 11, information: 'FEE FIXING NORMS', link: 'https://drive.google.com/file/d/1pF6dwmSVPFbf1aF3ELXdeRtG-jflyobe/view?usp=sharing',linkText: 'View', highlight: true},
     
      // {slno: 5, information: 'LIST OF THE PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS', view: 'View', highlight: true},
      // 
  ]);

  dataSource3 = new MatTableDataSource([
    {slno: 1, information: 'PRINCIPAL',  link: '', linkText: '1' , highlight: false,},
    {slno: 2, information: 'TOTAL NO OF TEACHERS AND DETAILS', link: '', linkText: '48', highlight: false},
    {slno: 3, information: 'TEACHER SECTION RATIO', link: '', linkText: '1:1.5', highlight: false},
    {slno: 4, information: 'DETAILS OF SPECIAL EDUCATOR', link: '', linkText: 'View', highlight: true},
    {slno: 5, information: 'DETAILS OF COUNCELLOR AND WELNESS TEACHER', link: '', linkText: 'View', highlight: true},
    {slno: 6, information: 'STAFF DETAILS', link: '', linkText: 'View', highlight: false},
  
   
   
    // {slno: 5, information: 'LIST OF THE PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS', view: 'View', highlight: true},
    // 
]);
dataSource4 = new MatTableDataSource([
  {slno: 1, information: 'TOTAL CAMPUS AREA OF THE SCHOOL(METER SQUARE)',  link: '', linkText: '8134' , highlight: false,},
  {slno: 2, information: 'NO AND SIZE OF CLASSROOMS', link: '', linkText: '35,500 SQFT', highlight: false},
  {slno: 3, information: 'NO AND SIZE OF LABORATRIES ', link: '', linkText: '7,600 SQFT', highlight: false},
  {slno: 4, information: 'INTERNET FACILITY', link: '', linkText: 'YES', highlight: true},
  {slno: 5, information: 'NO OF GIRLS TOILETS', link: '', linkText: '8', highlight: true},
  {slno: 6, information: 'NO OF BOYS TOILETS', link: '', linkText: '8', highlight: true},
  {slno: 7, information: 'LIBRARY FACILITY', link: '', linkText: 'View', highlight: true},
  {slno: 8, information: 'YOUTUBE VIDEO OF SCHOOL INFRASTRUCTURE', link: '', linkText: 'View', highlight: true},
   {slno: 9, information: 'SCHOOL INFRASTRUCTURE DETAILS', link: '', linkText: 'View', highlight: true},
 
 
 
 
  // {slno: 5, information: 'LIST OF THE PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS', view: 'View', highlight: true},
  // 
]);
}
